export const CATEGORY = 'CATEGORY';
export const GET_CATEGORY_REQUEST = `${CATEGORY}/getCategoryRequest`;
export const CREATE_CATEGORY_REQUEST = `${CATEGORY}/createCategoryRequest`;
export const UPDATE_CATEGORY_REQUEST = `${CATEGORY}/updateCategoryRequest`;
export const REMOVE_CATEGORY_REQUEST = `${CATEGORY}/removeCategoryRequest`;
export const GET_MENU_ITEMS_REQUEST = `${CATEGORY}/getMenuItemsRequest`;
export const CREATE_MENU_ITEM_REQUEST = `${CATEGORY}/createMenuItemRequest`;
export const REMOVE_MENU_ITEM_REQUEST = `${CATEGORY}/removeMenuItemRequest`;
export const UPDATE_MENU_ITEM_REQUEST = `${CATEGORY}/updateMenuItemsRequest`;
